import React from 'react';
import { HeroBanner, KpiRow } from './HeroKpi';
import { SalesTrend, VerticalDonut, TopCustomers } from './Charts';
import { ActivityFeed, StockPosition, AlertsPanel } from './Panels';

const Skeleton = () => (
  <div className="space-y-4" data-testid="dashboard-loading">
    <div className="erp-skeleton h-[210px]" />
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">{[...Array(6)].map((_, i) => <div key={i} className="erp-skeleton h-[128px]" />)}</div>
    <div className="grid lg:grid-cols-3 gap-4">{[...Array(3)].map((_, i) => <div key={i} className="erp-skeleton h-[280px]" />)}</div>
  </div>
);

export const Dashboard = ({ user, data, go }) => {
  if (!data) return <Skeleton />;
  return (
    <div className="space-y-4" data-testid="erp-dashboard">
      <HeroBanner user={user} />
      <KpiRow data={data} />
      <div className="grid lg:grid-cols-[1.25fr_1fr_1fr] gap-4">
        <SalesTrend data={data} />
        <VerticalDonut data={data} />
        <TopCustomers data={data} go={go} />
      </div>
      <div className="grid lg:grid-cols-3 gap-4">
        <ActivityFeed items={data.activities} go={go} />
        <StockPosition rows={data.stock_position} go={go} />
        <AlertsPanel alerts={data.alerts} go={go} />
      </div>
    </div>
  );
};
